import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../lib/axios";
import toast from "react-hot-toast";
import { uppercasePayload } from "../lib/uppercasePayload";

const initialState = {
  getallCategory: [],
  pagination: { page: 1, pageSize: 5, totalItems: 0, totalPages: 1 },
  isgetallCategory: false,
  iscreatedCategory: false,
  iscategoryremove: false,
  searchdata: null,
};

export const CreateCategory = createAsyncThunk(
  "category/createcategory",
  async (Category, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "category",
        uppercasePayload(Category),
        {
          withCredentials: true,
        },
      );
      return response.data;
    } catch (error) {
      console.error("CreateCategory error:", error.response || error);
      return rejectWithValue(
        error.response?.data?.message || "Category add failed",
      );
    }
  },
);

export const gettingallCategory = createAsyncThunk(
  "category/getcategory",
  async (
    { page = 1, pageSize = 5, sortDir = "desc" } = {},
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.get("category", {
        params: { page, pageSize, sortDir },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  },
);

export const RemoveCategory = createAsyncThunk(
  "category/removecategory",
  async (CategoryId, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`category/${CategoryId}`);
      return CategoryId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  },
);

export const SearchCategory = createAsyncThunk(
  "category/searchcategory",
  async (query, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `category/search?query=${query}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  },
);

export const UpdateCategory = createAsyncThunk(
  "category/updatecategory",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `category/${id}`,
        { updatedCategory: uppercasePayload(data) },
        {
          withCredentials: true,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Update failed");
    }
  },
);

const categorySlice = createSlice({
  name: "category",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(gettingallCategory.pending, (state) => {
        state.isgetallCategory = true;
      })
      .addCase(gettingallCategory.fulfilled, (state, action) => {
        state.isgetallCategory = false;
        state.getallCategory = action.payload.categoriesWithCount;
        state.pagination = action.payload.pagination || state.pagination;
      })

      .addCase(gettingallCategory.rejected, (state, action) => {
        state.isgetallCategory = false;
      })

      .addCase(CreateCategory.pending, (state) => {
        state.iscreatedCategory = true;
      })
      .addCase(CreateCategory.fulfilled, (state, action) => {
        state.iscreatedCategory = false;
        if (Array.isArray(state.getallCategory)) {
          state.getallCategory.unshift(action.payload);
        }
      })

      .addCase(CreateCategory.rejected, (state, action) => {
        state.iscreatedCategory = false;
      })

      .addCase(RemoveCategory.pending, (state) => {
        state.iscategoryremove = true;
      })

      .addCase(RemoveCategory.fulfilled, (state, action) => {
        state.iscategoryremove = true;
        state.getallCategory = state.getallCategory.filter(
          (category) => category.id !== action.meta.arg,
        );
      })
      .addCase(UpdateCategory.fulfilled, (state, action) => {
        const updatedCategory = action.payload;
        state.getallCategory = state.getallCategory.map((cat) =>
          cat.id === updatedCategory.id ? updatedCategory : cat,
        );
        state.iscreatedCategory = false; // optional: reset form state flags
      })
      .addCase(RemoveCategory.rejected, (state, action) => {
        state.iscategoryremove = true;
      })

      .addCase(SearchCategory.fulfilled, (state, action) => {
        state.searchdata = action.payload;
      })

      .addCase(SearchCategory.rejected, (state, action) => {});
  },
});

export default categorySlice.reducer;
